// AnimatedIdlePokemon.tsx
import { S3_BASE_URL } from "@/utils/s3";
import { loadAnimXML } from "@/utils/sprites/sheet-cut";
import { Pokemon } from "prisma-layer";
import { parsePokeNameForSprite } from "utils/pokemon/name-utils";
import React, { useEffect, useState } from "react";

export type PokemonPortraitProps = {
  pokemon: Pick<Pokemon, "base_pokemon_name" | "is_shiny">;
  emotion?: "Normal";
  className?: string;
  style?: React.CSSProperties;
};

export const PokemonPortrait = ({
  pokemon,
  emotion = "Normal",
  className,
  style,
}: PokemonPortraitProps) => {
  const [portraitProps, setPortraitProps] = useState<{
    src: string;
    width: number;
    height: number;
  } | null>(null);

  const initPortrait = async () => {
    let parsedPokemonName = parsePokeNameForSprite(pokemon.base_pokemon_name);

    if ((pokemon as any).is_shiny) {
      parsedPokemonName += "__shiny";
    }

    const portraitUrl = `${S3_BASE_URL}/pokemons/${parsedPokemonName}/portraits/${emotion}.png`;

    const portraitImage = new Image();
    portraitImage.src = portraitUrl;
    portraitImage.width = portraitImage.width;

    portraitImage.onload = () => {
      setPortraitProps({
        src: portraitImage.src,
        width: portraitImage.width,
        height: portraitImage.height,
      });
    };
  };

  useEffect(() => {
    initPortrait();
  }, [pokemon.base_pokemon_name, emotion]);

  if (!portraitProps) {
    return (
      <div className="w-full h-full bg-pk-black/30 rounded-xl p-2 pb-4 animate-pulse" />
    );
  }

  return (
    <img
      className={`${className ?? ""}`}
      src={portraitProps.src}
      style={style}
      alt={pokemon.base_pokemon_name}
      aria-hidden
    />
  );
};
